import React, { useMemo } from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const DocumentStatusFilter = ({ value = '', onChange }) => {
  const { dashboard, eInvoiceForm } = useTranslatedMessages();

  const options = useMemo(() => {
    const statusT = dashboard?.document_status ?? {};
    return [
      { value: 'PENDING', label: statusT.pending ?? 'Pending' },
      { value: 'REJECTED', label: statusT.rejected ?? 'Rejected' },
      { value: 'APPROVED', label: statusT.approved ?? 'Approved' },
      {
        value: 'VALIDATION_FAILED',
        label: statusT.validation_failed ?? 'Validation Failed',
      },
    ];
  }, [dashboard]);

  const statusLabel = eInvoiceForm?.document_tables?.invoice?.status ?? 'Status';
  const selectedOption = options.find((option) => option.value === value) || null;

  const handleChange = (_, selected) => {
    onChange(selected?.value || null);
  };

  return (
    <Autocomplete
      value={selectedOption}
      options={options}
      getOptionLabel={(option) => option.label || ''}
      isOptionEqualToValue={(option, optionValue) => option?.value === optionValue?.value}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField {...params} label={statusLabel} variant="outlined" size="small" sx={{ minWidth: 200 }} />
      )}
      clearOnBlur={false}
    />
  );
};

export default DocumentStatusFilter;
